import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import PrimaryLinkButton from "../Button/PrimaryLinkButton";
import LineArrowRight from "../Icons/LineArrowRight"
import {CarDefault, CardFigure, CarDefaultBody, CardDesc, CardTitle, CardLink} from "../Section"

const ApplyFinancingCard = () => (
	<CarDefault className='card card-default'>
    <CardFigure>
		  <StaticImage src="../../images/financing.png" placeholder="blurred" formats={["AUTO", "WEBP", "AVIF"]} alt="limited warranty" />

    </CardFigure>
    <CarDefaultBody className='card-body'>
      <CardTitle className="card-title">100% Financing</CardTitle>
      <CardDesc>
        <p>Taking advantage of our financing service comes with its own list of benefits and features. Here are a few ways our finance program can help you:</p>
      </CardDesc>
      <CardLink><Link to="/financing"><PrimaryLinkButton text="Apply Now" icon={<LineArrowRight />} /></Link></CardLink>
    </CarDefaultBody>
	</CarDefault>
);

export default ApplyFinancingCard;